export default "__VITE_ASSET__46a7f5e5__"